import React from 'react';

import Popover from 'components/shared/Popovers/Popover/Popover';

const RowActions = ({ data, onEnroll, onUnenroll }) => {
  if (!data) return null;

  const isEnrolled = !!data?.veradigm_user_id;

  const options = isEnrolled
    ? [
        {
          label: 'Un-enroll',
          icon: 'minus-circle-mono',
          onClick: () => onUnenroll?.(data)
        }
      ]
    : [
        {
          label: 'Enroll',
          icon: 'add-square-mono',
          onClick: () => onEnroll?.(data)
        }
      ];

  return (
    <Popover
      className="flex h-full w-full items-center justify-center"
      position="left"
      isFixed
      icon="context-menu-horizontal"
      options={options}
      isBorder={false}
    />
  );
};

export default RowActions;
